import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import HeroCardLayout from "../layout/HeroCardLayout";
import "../../styles/components/entryflow/MicrophonePermissioning.css";

interface Props {
  onAcceptAndContinue: () => void;
  permissionMode: boolean;
  botName?: string;
};

const MicrophonePermissioningView: React.FC<Props> = ({ onAcceptAndContinue, permissionMode, botName }) => {
  const { t } = useTranslation();
  const [acceptDisabled, setAcceptDisabled] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  if (permissionMode) {
    return (
      <div className="microphone-permission-container">
        <div className="microphone-permission-prompt">
          {t("microphone.browserPrompt")}
        </div>
      </div>
    );
  }

  const acceptPressed = (e: React.FormEvent) => {
    e.preventDefault();
    if (!acceptDisabled) {
      setAcceptDisabled(true);
      onAcceptAndContinue();
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !acceptDisabled) {
      e.preventDefault();
      setAcceptDisabled(true);
      onAcceptAndContinue();
    }
  }

  useEffect(() => {
    if (!permissionMode) {
      formRef.current?.focus();
    }
  }, [permissionMode]);

  return (
    <form 
      ref={formRef}
      className="microphone-permission-container"
      onSubmit={acceptPressed}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
      style={{ outline: 'none' }}
    >
      <div className="microphone-permission-message">
        {t("microphone.needAccess", { botName: botName || "Bella" })}
      </div>
      <button
        type="submit"
        className="entryflow-submit-button"
        disabled={acceptDisabled}
      >
        {t("microphone.acceptAndContinue")}
      </button>
      <div className="microphone-permission-disclaimer">
        {t("microphone.disclaimerPrefix")}{" "}
        <a
          className="microphone-permission-link"
          href="https://www.persona-ai.ai/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("auth.termsAndConditions")}
        </a>{" "}
        {t("microphone.disclaimerAnd")}{" "}
        <a
          className="microphone-permission-link"
          href="https://www.persona-ai.ai/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("auth.privacyPolicy")}
        </a>
        {t("microphone.disclaimerSuffix")}
      </div>
    </form>
  );
};

const MicrophonePermissioningOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <MicrophonePermissioningView onAcceptAndContinue={() => {}} permissionMode={false} botName={"Colin"} />
    </HeroCardLayout>
  );
};

export default MicrophonePermissioningView;
export { MicrophonePermissioningOnlyComponent };
